import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'

export default class {
  @observable data = {
    uid: 0,
    userInfo: {
      avatarurl: ''
    },
    remaintime: 0,
    gifts: {},
    gemstone: {},
    rank: [],
    thisGoldRank: [],
    gold: [],
    nationalList: {},
    lastUserRank: [],
    myRank: {},
    thisMyUserRank: {},
    lastMyUserRank: {},
    // 倒计时
    remaintime: 0,
    now: 0
  }

  @action async GetUserInfoWeb() {
    this.data.notNetwork = false
    let d = await http.post('/web/MyAccountInfo', {})
    if (d && d.code == 0 && d.res && d.res.uid > 0) {
      this.data.userInfo = d.res
    } else {
      this.data.notNetwork = true
    }
  }

  // 活动礼物
  @action async GetGifts(val) {
    this.data.notNetwork = false
    let d = await http.post('/web/national/star/gift', { week: val })
    this.data.gifts = d.res || []
    console.log(d, '礼物')
  }
  // 国家宝石总计
  @action async GetGemstone(val) {
    this.data.notNetwork = false
    let d = await http.post('/web/national/star/gold', { week: val })
    this.data.gemstone = d.res
  }
  // 用户周排行
  @action async GetUserRank(val) {
    this.data.notNetwork = false
    let d = await http.post('/web/national/star/rank_user', { week: val })
    let lastUserRank = await http.post('/web/national/star/rank_user', { week: 'last' })
    let thisMyUserRank = await http.post('/web/national/star/rank_user', { week: 'this' })
    let lastMyUserRank = await http.post('/web/national/star/rank_user', { week: 'last' })
    this.data.rank = (d && d.res && d.res.list) || []
    this.data.lastUserRank = lastUserRank && lastUserRank.res && lastUserRank.res.list
    this.data.thisMyUserRank = (thisMyUserRank && thisMyUserRank.res && thisMyUserRank.res.myrank) || {}
    this.data.lastMyUserRank = (lastMyUserRank && lastMyUserRank.res && lastMyUserRank.res.myrank) || {}
  }
  // 国家金币周排行
  @action async GetGold(val) {
    this.data.notNetwork = false
    let d = await http.post('/web/national/star/rank/country', { week: val })
    let lastData = await http.post('/web/national/star/rank/country', { week: 'last' })
    let myRank = await http.post('/web/national/star/rank/country', { week: 'this' })
    this.data.thisGoldRank = (d.res && d.res.list) || []
    this.data.gold = (lastData.res && lastData.res.list) || []
    this.data.myRank = (myRank && myRank.res && myRank.res.myrank) || {}
  }
  // 国家列表
  @action async GetNationalList() {
    this.data.notNetwork = false
    let d = await http.post('/web/country', {})
    this.data.nationalList = d.res
  }
  // 倒计时
  @action async GetServerTime(map) {
    let d = await http.post('/web/national/count/down', map)
    if (d.code == 0) {
      // this.data.now = d.res.now
      let ts = d.res
      if (ts > 0) {
        this.data.remaintime = ts
      }
    }
  }
  // 奖励列表
  @action async getRewardList() {
    let d = await http.post('/web/national/star/reward')
    console.log(d, '奖励列表')
    return d.res
  }
}



// WEBPACK FOOTER //
// src/store/activity/national.js